module.exports = __webpack_public_path__ + "static/media/bg-spacer-desk.1befb53a.svg";